import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSubscriberDomainParams } from 'global/hooks/useSubscriberDomainParams';
import MedicalCategoryPageStore, {
  MedicalCategoryPageStoreContext,
} from 'store/pages/subscriber/imq/medical-category/pageStore';
import PageContent from 'components/subscriber/imq/medical-category';

const MedicalCategoryPage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberDomainParams();
  const { category: categoryParam } = useParams<{ category: string }>();

  if (!categoryParam) {
    throw new Error('MedicalCategoryPage requires a category param in the url');
  }

  const category = decodeURIComponent(categoryParam);

  const pageStore = useMemo(
    () => new MedicalCategoryPageStore({ groupId, subscriberId, entityId, category }),
    [groupId, subscriberId, entityId, category],
  );

  return (
    <MedicalCategoryPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </MedicalCategoryPageStoreContext.Provider>
  );
};

export default MedicalCategoryPage;
